module.exports = __webpack_public_path__ + "img/intabuildtmwy@2x.ab4dd3fb.png";